var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 104,
    viewBox: "0 0 88 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0228 7.78548C42.3036 6.46864 45.1137 6.46864 47.3945 7.78548L76.7314 24.7231C79.0122 26.04 80.4172 28.4736 80.4172 31.1072V64.9825C80.4172 67.6162 79.0122 70.0498 76.7314 71.3667L47.3945 88.3043C45.1137 89.6211 42.3036 89.6211 40.0227 88.3043L10.6859 71.3666C8.40504 70.0498 7 67.6162 7 64.9825V31.1072C7 28.4736 8.40504 26.04 10.6859 24.7231L40.0228 7.78548Z",
    fill: "#C9E9F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8837_41826",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 65,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.864 12.915C42.7172 11.8451 45.0004 11.8451 46.8535 12.915L72.7845 27.8863C74.6377 28.9562 75.7793 30.9335 75.7793 33.0734V63.0159C75.7793 65.1558 74.6377 67.1331 72.7845 68.203L46.8535 83.1742C45.0004 84.2442 42.7172 84.2442 40.864 83.1742L14.933 68.203C13.0798 67.1331 11.9382 65.1557 11.9382 63.0159V33.0733C11.9382 30.9335 13.0798 28.9562 14.933 27.8863L40.864 12.915Z",
    fill: "#8D61E8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8837_41826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.864 12.915C42.7172 11.8451 45.0004 11.8451 46.8535 12.915L72.7845 27.8863C74.6377 28.9562 75.7793 30.9335 75.7793 33.0734V63.0159C75.7793 65.1558 74.6377 67.1331 72.7845 68.203L46.8535 83.1742C45.0004 84.2442 42.7172 84.2442 40.864 83.1742L14.933 68.203C13.0798 67.1331 11.9382 65.1557 11.9382 63.0159V33.0733C11.9382 30.9335 13.0798 28.9562 14.933 27.8863L40.864 12.915Z",
    fill: "#E7F4FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.846 45.06C72.2298 83.5011 12.5546 43.3756 6.58582 9.86806L-27.8162 57.6638L55.5728 117.685L107.846 45.06Z",
    fill: "#86D1F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8837_41826",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 82,
    height: 82
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2998 8.42166C3.2998 5.11374 5.98141 2.43213 9.28934 2.43213H78.3993C81.7072 2.43213 84.3888 5.11373 84.3888 8.42166V49.9236C84.3888 52.2916 82.4692 54.2113 80.1012 54.2113C77.7332 54.2113 75.8136 56.1309 75.8136 58.4989V63.0136C75.8136 65.1547 74.6706 67.133 72.8157 68.2025L46.838 83.18C44.9853 84.2481 42.7037 84.2475 40.8517 83.1783L14.9121 68.203C13.0588 67.1331 11.9171 65.1558 11.9171 63.0159V58.5199C11.9171 56.1403 9.98809 54.2113 7.60848 54.2113C5.22886 54.2113 3.2998 52.2822 3.2998 49.9026V8.42166Z",
    fill: "#FCCE2C"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8837_41826)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3826 63.7514C5.70762 63.7514 6.48677 70.8011 7.46072 74.326L6 85.6056L19.1483 99L33.027 90.5404C37.4098 88.4254 38.8707 82.7857 33.7575 78.5558C35.9489 76.4409 34.488 70.8012 28.6443 69.3912C32.1505 65.4434 27.1834 63.9864 24.2615 63.7514C24.2615 60.2265 20.6092 59.5216 17.6874 58.8166C16.2264 56.7017 8.92184 58.8166 10.3826 63.7514Z",
    fill: "#7B9F5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38256 66.7514C-0.292384 66.7514 0.486774 73.8011 1.46072 77.326L0 88.6056L13.1483 102L27.027 93.5404C31.4098 91.4254 32.8707 85.7857 27.7575 81.5558C29.9489 79.4409 28.488 73.8012 22.6443 72.3912C26.1505 68.4434 21.1834 66.9864 18.2615 66.7514C18.2615 63.2265 14.6092 62.5216 11.6874 61.8166C10.2264 59.7017 2.92184 61.8166 4.38256 66.7514Z",
    fill: "#6D914F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5432 68.3118L77.5393 68.3258L79 79.6054L65.8517 92.9998L51.973 84.5402C47.5902 82.4253 46.1293 76.7855 51.2425 72.5557C49.0511 70.4408 50.512 64.801 56.3557 63.3911C54.5 59.4998 57.5 58.4998 59.5 58.9998C59.5 55.4749 63.5 53.4998 65.8517 54.4998C68.5 50.4998 76.3826 50.7484 76 56.9999C80.6688 56.9999 78.5189 64.7803 77.5432 68.3118Z",
    fill: "#7B9F5D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5432 74.4758L80.5393 74.4899L82 85.7694L68.8517 99.1639L54.973 90.7042C50.5902 88.5893 49.1293 82.9496 54.2425 78.7197C52.0511 76.6048 53.512 70.9651 59.3557 69.5551C57.5 65.6639 60.5 64.6639 62.5 65.1639C62.5 61.639 66.5 59.6639 68.8517 60.6639C71.5 56.6639 79.3826 56.9125 79 63.1639C83.6688 63.1639 81.5189 70.9444 80.5432 74.4758Z",
    fill: "#6D914F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 35.5,
    r: 8.5,
    fill: "#FFE27D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8694 13.7375V12.8366L45.9856 12.8057V14.1396L41.8694 13.7375Z",
    fill: "#3D4C49"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8978 74.0892L58.2927 65.6062C58.2927 65.6062 53.0153 56.1952 51.9421 52.901C48.8731 43.5325 45.6538 14.6152 45.6538 14.6152H42.1286C42.1286 14.6152 39.8268 43.7645 36.6231 53.1562C35.5085 56.4195 29.7126 65.6062 29.7126 65.6062L18.349 78.2766L15.0156 81.9961H31.0709C31.0709 81.9961 32.3721 79.0344 35.6899 76.7493C37.7014 75.3651 40.4593 74.2284 44.1141 74.1511C46.815 74.0969 49.039 74.615 50.8587 75.4115C55.9339 77.6309 57.8261 81.9923 57.8261 81.9923H73.0001L65.9082 74.0853L65.8978 74.0892ZM38.7589 65.2891L43.0306 53.2335L46.1359 53.075L49.0598 65.4825L38.7589 65.2891Z",
    fill: "#6F827C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0513 81.9962H57.8159C57.8159 81.9962 54.3322 73.9462 44.1039 74.1511C34.4148 74.3483 31.0606 81.9962 31.0606 81.9962H26.8252L34.5703 71.4098L52.9273 71.7964L62.0565 82L62.0513 81.9962Z",
    fill: "#4C5B59"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0815 12.8442L46.6545 12.7901L46.3486 11.2241L43.995 9.08984H43.404L41.3407 11.0115L41.0815 12.8442Z",
    fill: "#6F827C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4038 9.09006V0H43.6008L43.9948 9.09006H43.4038Z",
    fill: "#3D4C49"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3936 52.7192L44.2023 29.2227L45.4517 52.7192H43.3936Z",
    fill: "#3D4C49"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4327 65.2079L42.8802 55.2324H45.6174L48.4946 65.4708L49.0596 65.4824L46.1358 53.075L43.0305 53.2335L38.7588 65.2852L39.4327 65.2079Z",
    fill: "#3D4C49"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.109 70.7292L63.9329 71.8969L64.0988 72.0825L24.8135 71.0579L25.109 70.7292Z",
    fill: "#6F827C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0302 15.7365L45.7576 15.5664L45.9079 16.8462L41.885 17.403L42.0302 15.7365Z",
    fill: "#3D4C49"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1365 66.2675L28.7223 66.7005L59.433 66.8784L60.2625 66.5188L28.1365 66.2675Z",
    fill: "#4C5B59"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.409 81.9961C63.409 81.9961 57.3747 72.8635 43.9115 72.8635C30.4483 72.8635 25.5027 81.9961 25.5027 81.9961H26.8246C26.8246 81.9961 31.0341 73.3198 43.9996 73.3198C56.9651 73.3198 62.0559 81.9961 62.0559 81.9961H63.4142H63.409Z",
    fill: "#6F827C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4155 81.219L25.4981 71.4059L33.4765 71.634L26.1098 81.0604L16.4155 81.219Z",
    fill: "#4C5B59"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2849 72.3724H63.409L71.5947 81.9961H63.409L54.2849 72.3724Z",
    fill: "#4C5B59"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8228 64.6586C31.8228 64.6586 35.6901 58.306 36.9809 54.5903H41.2527L37.8571 64.763L31.8228 64.6586Z",
    fill: "#4C5B59"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2087 54.5055L50.0185 64.9721L57.043 65.0958C57.043 65.0958 53.1135 59.9689 51.5219 54.4746L47.2087 54.5094V54.5055Z",
    fill: "#4C5B59"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8154 52.8236C37.8154 52.8236 42.0871 33.9669 42.1649 17.3643L43.7098 17.1516C43.7098 17.1516 43.7875 43.0995 41.999 52.7231L37.8154 52.8275V52.8236Z",
    fill: "#4C5B59"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3538 52.7192L44.052 17.1013L45.431 16.9119C45.431 16.9119 47.7742 40.8569 50.8847 52.3171L46.3589 52.7192H46.3538Z",
    fill: "#4C5B59"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8846 17.403L41.7031 19.4406H46.2185L45.9074 16.8462L41.8846 17.403Z",
    fill: "#6F827C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7031 19.4407H46.2185L46.2496 19.7036L41.6616 19.9046L41.7031 19.4407Z",
    fill: "#4C5B59"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4155 81.219L25.4981 71.4059L33.4765 71.634L33.1291 72.0825L25.804 71.8003L17.188 81.0759L16.4155 81.219Z",
    fill: "#4C5B59"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2849 72.3724H63.409L71.5947 81.9961H71.1696L62.9424 72.6276L54.4819 72.5812L54.2849 72.3724Z",
    fill: "#4C5B59"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5646 71.4059L34.3262 71.7307L53.1808 72.0825L52.9216 71.7925L34.5646 71.4059Z",
    fill: "#4C5B59"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0436 65.0956H56.6185C56.6185 65.0956 53.4043 59.7792 51.2374 54.08C49.0704 48.3809 45.4312 19.6724 45.4312 19.6724H45.7163C45.7163 19.6724 49.283 47.6733 51.4447 53.6431C53.6117 59.613 57.0384 65.0956 57.0384 65.0956H57.0436Z",
    fill: "#4C5B59"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5527 65.0956H31.9778C31.9778 65.0956 35.192 59.7792 37.359 54.08C39.5259 48.3809 43.1652 19.6724 43.1652 19.6724H42.88C42.88 19.6724 39.3134 47.6733 37.1516 53.6431C34.9846 59.613 31.5579 65.0956 31.5579 65.0956H31.5527Z",
    fill: "#4C5B59"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0886 52.5956L35.1975 53.6434L52.9065 52.8237V52.1316C52.9065 52.1316 48.5155 52.5917 44.2801 52.6613C40.5527 52.7232 35.0886 52.5917 35.0886 52.5917V52.5956Z",
    fill: "#6F827C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1976 53.6434C35.1976 53.6434 35.7886 53.7749 36.0167 54.5868L52.5488 54.467C52.5488 54.467 52.3985 53.628 52.9014 52.8237L35.1924 53.6434H35.1976Z",
    fill: "#4C5B59"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1368 66.2673V64.5931C28.1368 64.5931 36.7424 65.3896 44.1972 65.3896C52.9013 65.3896 60.2576 65.1538 60.2576 65.1538V66.5225L28.1316 66.2712L28.1368 66.2673Z",
    fill: "#6F827C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9753 70.6365L29.894 67.2843H32.2839L29.8681 70.6365H26.9753Z",
    fill: "#4C5B59"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2261 70.6365L33.476 67.2843H35.8659L34.1188 70.6365H31.2261Z",
    fill: "#4C5B59"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4775 70.6365L37.3594 67.2843H39.7493L38.3703 70.6365H35.4775Z",
    fill: "#4C5B59"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7332 70.6365L41.1899 67.2843H43.5798L42.6207 70.6365H39.7332Z",
    fill: "#4C5B59"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4612 70.6365L44.71 67.2843H47.0999L47.3487 70.6365H44.4612Z",
    fill: "#4C5B59"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2353 70.6365L47.8672 67.2843H50.2571L51.1228 70.6365H48.2353Z",
    fill: "#4C5B59"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4866 70.6365L50.9314 67.2843H53.3213L55.3742 70.6365H52.4866Z",
    fill: "#4C5B59"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8264 70.6365L55.3743 67.2843H57.7641L60.7139 70.6365H57.8264Z",
    fill: "#4C5B59"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1336 67.4892L30.0392 67.4931L27.3382 70.6365H26.9753L29.894 67.2843H32.2839L32.1336 67.4892Z",
    fill: "#4C5B59"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3743 67.2843L55.5142 67.4738L57.7123 67.6168L60.491 70.6365H60.7139L57.7641 67.2843H55.3743Z",
    fill: "#4C5B59"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9781 67.3848L53.1813 67.4931L55.1254 70.6365H55.3742L53.3213 67.2843H50.9314L50.9781 67.3848Z",
    fill: "#4C5B59"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8672 67.2843L47.8827 67.4506H50.2985L50.2571 67.2843H47.8672Z",
    fill: "#4C5B59"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7103 67.2843L44.7 67.4506H47.1106L47.1002 67.2843H44.7103Z",
    fill: "#4C5B59"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8659 67.2843H33.476L31.2261 70.6365H31.5527L33.5486 67.3655H35.8244L35.8659 67.2843Z",
    fill: "#4C5B59"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3589 67.2843L37.3123 67.3665H39.7125L39.7488 67.2843H37.3589Z",
    fill: "#4C5B59"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1901 67.2843L41.1538 67.3655L43.5333 67.4506L43.58 67.2843H41.1901Z",
    fill: "#4C5B59"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7225 66.7004L28.3337 67.1374L60.4753 68.0382L59.4333 66.8783L28.7225 66.7004Z",
    fill: "#3F4D4B"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0954 47.7122L43.404 42.7438L39.9306 35.614L43.7565 29.2227L41.351 23.1292L43.9587 19.9045L43.9949 20.5348L41.7036 23.1021L44.052 29.2227L43.9949 29.7254L40.449 35.5908L43.404 42.1019V43.749L38.1265 48.1645L42.9063 52.1315L42.0198 52.3171L37.8569 48.6556L38.0954 47.7122Z",
    fill: "#6F827C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3175 52.1316L50.0034 47.7432L45.4517 43.1112L45.5295 42.3843L47.8779 35.1463L44.4149 29.3195L46.2501 24.4091L44.052 19.9046L44.1246 19.7964L46.3123 24.1848L46.4004 24.846L44.8504 29.4548L48.3496 35.0496L46.0531 42.9952L50.6203 47.8128L46.4315 52.5956L46.3278 52.3018L46.3175 52.1316Z",
    fill: "#6F827C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2528 54.5903L34.7312 59.2765L37.8572 64.763L38.2409 64.1173L35.1978 59.2765L40.9522 55.4835L41.2528 54.5903Z",
    fill: "#6F827C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2087 54.5056L53.8652 59.2768L50.0185 64.9721L49.6971 64.3264L53.4608 59.2768L47.2087 55.0392V54.5056Z",
    fill: "#6F827C"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1975 56.0714L53.3627 56.2338L52.554 54.4668L36.0166 54.5905L35.1975 56.0714Z",
    fill: "#6F827C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1975 56.0715V56.2301L53.4145 56.3422L53.3627 56.0715H35.1975Z",
    fill: "#4C5B59"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.28
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0169 54.5905L35.6799 55.2942L52.6683 54.7181L52.5542 54.4668L36.0169 54.5905Z",
    fill: "#3F4D4B"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1288 72.0825L21.7185 75.4889L26.1095 81.0605L26.6642 80.4612L22.6776 75.8098L32.9007 72.3725L33.1288 72.0825Z",
    fill: "#6F827C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2849 72.3724L66.7579 76.3124L63.409 81.9961L62.9424 81.3697L65.944 76.5714L54.7515 72.8635L54.2849 72.3724Z",
    fill: "#6F827C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3386 78.2765L35.6743 76.7493C32.3565 79.0343 31.0552 81.9961 31.0552 81.9961H15L18.3334 78.2765H18.3386Z",
    fill: "#4D5C5A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9898 81.9962H57.8159C57.8159 81.9962 55.9288 77.6309 50.8484 75.4154L65.8979 74.0892L72.9898 81.9962Z",
    fill: "#4D5C5A"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0513 81.996H57.8159C57.8159 81.996 54.3322 73.9461 44.1039 74.151C34.4148 74.3482 31.0606 81.996 31.0606 81.996H26.8252C26.8252 81.996 31.2265 73.3197 44.0002 73.3197C56.7739 73.3197 62.0565 81.996 62.0565 81.996H62.0513Z",
    fill: "#3D4C49"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1975 53.6434H52.5851L52.9065 52.8237L35.1975 53.6434Z",
    fill: "#3F4D4B"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9983 13.6216L40.5317 15.9994C40.5317 15.9994 42.6935 15.7365 44.057 15.7365C45.7781 15.7365 47.4681 15.9994 47.4681 15.9994L46.9445 13.3586L41.0035 13.6216H40.9983Z",
    fill: "#6F827C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.ee04a058becd1635e97804b9acc0553f.svg";
export { ForwardRef as ReactComponent };